const CurrencyConverterContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/currency_converter/currency_converter_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>How to Use The Pips Currency Converter</h2>
              <p>
                Simply select your base and quote currencies, enter the amount,
                and get instant conversion results powered by live market data.
                Our converter updates rates in real time to ensure accuracy down
                to the decimal. From traders managing multiple pairs to
                investors tracking portfolio performance, The Pips Currency
                Converter helps you make confident decisions in an ever-changing
                market. It eliminates guesswork by providing clear, reliable
                values for every calculation. You can quickly compare rate
                changes over time to better understand market momentum. Designed
                for speed and simplicity, it ensures you always stay ahead of
                currency fluctuations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyConverterContentTwo;
